query GetInstallLocations {
    InstallLocations(limit: 100) {
        docs {
            id
            name
        }
    }
}
